import React from 'react'
import { MinimalLayout } from 'shared/layout/MinimalLayout'
import { NextPage } from 'next'
import { CampaignIDs } from 'types'
import { ExplorePageProps } from 'types/page'
import { explorePageInitialProps, PagePropsWrapper } from 'lib/routing/nextPageUtils'
import AffiliateHeader from 'components/layout/AffiliateHeader'
import MortgagePage from 'experiences/explore/simpleExplorePages/MortgagePage'
import { AffiliateFooter } from 'shared/layout/Footer'

const TransUnionMortgage: NextPage<PagePropsWrapper<ExplorePageProps>> = ({ metaTags }): JSX.Element => (
	<MinimalLayout metaTags={metaTags}>
		<AffiliateHeader headerStyle={'fiona_only'} />
		<MortgagePage campaign={CampaignIDs.BBMTU} articles={[]} />
		<AffiliateFooter />
	</MinimalLayout>
)

TransUnionMortgage.getInitialProps = explorePageInitialProps('/affiliate/transunion-mortgage')

export default TransUnionMortgage
